import { render, staticRenderFns } from "./subPopup.vue?vue&type=template&id=0bcb9e6e&"
import script from "./subPopup.vue?vue&type=script&lang=js&"
export * from "./subPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports